module.exports = __webpack_public_path__ + "img/woo-logo.63ea7a08.jpg";